import { TrolleyButtonContents } from './TrolleyButtonContents';

export default TrolleyButtonContents;
